/* global Syn */
import { hash, serializeQueryString } from './util';
import fetchJsonp from './fetch-jsonp';
import dlv from 'dlv';

/* global CLIENT,CONFIG */

// Ultimate fallback inline values when no option or config value exists for a key
const FALLBACK = {
	client: typeof CLIENT!=='undefined' ? CLIENT : 'aperture',
	site: typeof CLIENT!=='undefined' ? `${CLIENT}-gen4` : 'aperture-gen4',
	portalOrigin: dlv(window, 'Syn.Config.Framework.PortalRoot') || 'http://aperture.synacor.net/',
	portalAppServer: dlv(window, 'Syn.Config.Framework.AppServer') || 'appserv.jade.synacor.com'
};

// implements the simple fallback scheme giving precidence to an options object, then global config, then inline defaults
const cfg = (opts, key) => opts[key] || (typeof CONFIG!=='undefined' && CONFIG[key]) || FALLBACK[key];

// strip framework response down to just the data
const transformResponse = r => r && r.init && r.init.data;


/** Call into the framework's service/proxy endpoint on appserv
 *	@param {String} serviceName			The service to invoke (eg: sports)
 *	@param {Object} [params]			Parameters to pass to the service handler (can be nested)
 *	@param {Object} [options]
 *	@param {String} [options.origin]	The "sender origin" to pass (eg: "http://aperture.synacor.net"). Defaults to `location.origin`.
 *	@param {Object} [options.client]	Client name (eg: "aperture")
 *	@param {Object} [options.site]		Site name (eg: "aperture-gen4")
 *	@example
 *		service('sports', {
 *			sport: 'baseball',
 *			league: 'mlb',
 *			what: 'scores',
 *			queryString: {
 *				date: '2016-09-20'
 *			}
 *		}, {
 *			origin: 'http://start.att.net',
 *			client: 'att',
 *			site: 'att-gen4'
 *		}).then(console.log.bind(console));
 */
export default function service(serviceName, params={}, options={}, auth=false) {
	let query = {
		action: 'fetch',
		app_server: true,
		_is_jsonp: '1',
		service_name: serviceName,
		params,
		// everything is a service
		_uri: 'component://Synacor/Gen4/Configuration/Components/Service/',
		// http://start.att.net
		_root_url: options.origin || cfg(options, 'portalOrigin') || location.origin,
		// eg: att
		_client_uri: `client://client_config/${cfg(options, 'client')}/`,
		// eg: att-gen4
		_site_uri: `site://site_config/${cfg(options, 'site')}/`
		// '_parent_uri': 'zone://Synacor/Gen4/Configuration/Pages/Zones/Footer/',
		// '_page_uri': `page://Synacor/Gen4/Configuration/Pages/Home/`,
		// '_user_id': '',
		// '_auth_token': '',
		// '_session': cookies.session,	// || 'e17910b3bc7517c2f4fd3f68524a72914e53cc07-1465487956',
	};

	if (auth && dlv(window, 'Syn.Config.Framework.UserId')) {
		query._user_id = Syn.Config.Framework.UserId;
		query._auth_token = Syn.Config.Framework.AuthToken;

		if (dlv(window, 'Syn.Config.Framework.Session')) {
			query._session = Syn.Config.Framework.Session;
		}
	}

	if (options.cache === false) {
		//set up a query buster so that the browser doesn't cache to disk
		query._cbuster = new Date().getTime();
	}

	let queryString = serializeQueryString(query);

	let appServer = cfg(options, 'portalAppServer').replace(/https?:\/\//, '');

	return fetchJsonp(`//${appServer}/_/?${queryString}`, {
		callbackId: hash(queryString),
		cache: options.cache,
		dedupe: options.dedupe,
		timeout: options.timeout
	}).then(transformResponse);
}



// WEBPACK FOOTER //
// ../node_modules/@cube/framework-service/src/index.js